// dependencies
import React from "react";

// utils
import toEmployeeUrl from "../../utils/URLs/Employee";

// components
import Avatar from "../Avatar";
import Link from "../Link";
import Tooltip from "../Tooltip";
// styles
import css from "./AvatarGroup.module.scss";

export const getAvatarEntry = (
	hasLinks: boolean,
	canExpand: boolean,
	employeeNameTooltip: boolean,
	employee: { _id: string; name: string },
	style = {},
	size: number,
	border = true
) => {
	const avatarContent = (
		<div style={style} className={`${css.avatarContainer} ${border ? "" : css.noBorder}`}>
			<Avatar size={size} className={css.avatar} id={employee._id} />
		</div>
	);
	if (employeeNameTooltip) {
		return (
			<Tooltip id="avatar-tooltip" message={employee.name}>
				<Link href={`/employee-page/${employee._id}`} forceHardReload={true}>
					{avatarContent}
				</Link>
			</Tooltip>
		);
	}
	if (hasLinks && !canExpand) {
		return (
			<Link href={toEmployeeUrl(employee._id)} forceHardReload={true}>
				{avatarContent}
			</Link>
		);
	}
	return avatarContent;
};
